export default {
      id: "close_large-usage",
      viewBox: "0 0 166 166",
      url: __webpack_public_path__ + "sprite.svg#close_large",
      toString: function () {
        return this.url;
      }
    }